export default "__VITE_ASSET__912b0f04__$_?component__"